import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountLatestIndemnityAgreementQueryKey } from "../account.keys";

export const useAdminFetchAccountLatestIndemnityAgreement = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isFetching, isLoading, refetch } = useQuery({
		queryKey: accountLatestIndemnityAgreementQueryKey(accountId),
		queryFn: () =>
			get<Dtos.SuretyAccount.IndemnityAgreement.Get.Response | null>(
				`/v2/admin/surety/accounts/${accountId}/indemnity-agreements/latest`,
			),
		retry: false,
	});

	return {
		latestIndemnityAgreement: data,
		latestIndemnityAgreementError: error,
		latestIndemnityAgreementIsFetching: isFetching,
		latestIndemnityAgreementIsLoading: isLoading,
		refetchLatestIndemnityAgreement: refetch,
	};
};
